<template>
  <div>
    <div v-if="loading">正在处理授权回调...</div>
    <div v-else-if="errorMessage">{{ errorMessage }}</div>
    <div v-else>授权成功！正在跳转至主页...</div>
  </div>
</template>

<script>
import { setLoginInfo } from '@/utils';
import { getUserTokenByDingTalk} from '@/api/api'

export default {
  data() {
    return {
      loading: true,
      errorMessage: '',
      dingtalkId:''
    };
  },
  mounted() {
    this.handleDingTalkCallback();
  },
  methods: {
    async handleDingTalkCallback() {
      try {

       // alert(window.location.search);
        // 获取 URL 中的授权码
        const code = new URLSearchParams(window.location.search).get('code');
       // alert(code);
        if (!code) {
          throw new Error('未获取到有效的授权码');
        }
        getUserTokenByDingTalk({
            code: code
        }).then(response => {
          if (response.code === 0) {
              // 登录成功，保存登录信息
              console.error(response.data);
              setLoginInfo(response.data);
              this.$router.push({ path: '/home' })
          } else if (response.code === 1000) { // 假设 1000 是未绑定钉钉用户的错误码
             // 未绑定钉钉用户，跳转到绑定页面
              this.dingtalkId = response.msg;
              this.$router.push({ path: '/dingtalkbind/'+this.dingtalkId })
          }else {
              throw new Error(response.data.msg);
          }

        }).catch(error => {
          this.$message.error('获取用户信息失败，请重试');
        }); 

        
      } catch (error) {
        this.loading = false;
        this.errorMessage = `授权回调处理失败：${error.message}`;
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>    


// WEBPACK FOOTER //
// src/views/dingTalkAuth.vue